import React, { useState } from "react";
import { UploadCloud, Image as ImageIcon } from "lucide-react";
import { uploadPhotos } from "../api";
import { toast } from "sonner";

const UploadView = ({ projectId, onUploadComplete }) => {
  const [dragging, setDragging] = useState(false);
  const [uploading, setUploading] = useState(false);

  const handleDrop = async (e) => {
    e.preventDefault();
    setDragging(false);
    const files = Array.from(e.dataTransfer.files).filter(f => f.type.startsWith("image/"));
    if (files.length > 0) {
      await handleUpload(files);
    }
  };

  const handleFileSelect = async (e) => {
    const files = Array.from(e.target.files).filter(f => f.type.startsWith("image/"));
    if (files.length > 0) {
      await handleUpload(files);
    }
  };

  const handleUpload = async (files) => {
    setUploading(true);
    try {
      await uploadPhotos(projectId, files);
      toast.success(`Uploaded ${files.length} photos`);
      onUploadComplete();
    } catch (err) {
      console.error(err);
      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto">
      <div
        className={`border-2 border-dashed rounded-2xl p-12 text-center transition-colors ${
          dragging ? "border-indigo-500 bg-indigo-50" : "border-slate-300 hover:border-indigo-400 bg-white"
        }`}
        onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
        onDragLeave={() => setDragging(false)}
        onDrop={handleDrop}
      >
        <div className="w-16 h-16 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
          <UploadCloud className="w-8 h-8" />
        </div>
        <h3 className="text-xl font-bold text-slate-900 mb-2">Upload Photos</h3>
        <p className="text-slate-500 mb-6">Drag and drop your photos here, or click to select files.</p>
        
        <input
          type="file"
          id="file-upload"
          multiple
          accept="image/*"
          className="hidden"
          onChange={handleFileSelect}
        />
        <label
          htmlFor="file-upload"
          className={`inline-block px-6 py-3 rounded-lg font-medium cursor-pointer transition-colors ${
            uploading ? "bg-slate-300 text-slate-500 cursor-not-allowed" : "bg-indigo-600 text-white hover:bg-indigo-700"
          }`}
        >
          {uploading ? "Uploading..." : "Select Files"}
        </label>
      </div>
      
      <div className="mt-8 text-center text-slate-400 text-sm">
        <p>Supported formats: JPG, PNG, WEBP</p>
      </div>
    </div>
  );
};

export default UploadView;
